import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import MembershipSection from "../components/MembershipSection";
import ClassesSection from "../components/ClassesSection";
import CoachesSection from "../components/CoachesSection";
import GallerySection from "../components/GallerySection";
import TestimonialsSection from "../components/TestimonialsSection";
import FAQSection from "../components/FAQSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import ContactModal from "../components/ContactModal";
//import CalendarSection from "../components/CalendarSection";

const HomePage = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  // ✅ Open Contact form on every refresh / page load
  useEffect(() => {
    setIsContactOpen(true);
  }, []);

  // ✅ Close contact -> continue site
  const handleCloseContact = () => {
    setIsContactOpen(false);
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Contact form popup */}
      <ContactModal isOpen={isContactOpen} onClose={handleCloseContact} />

      {/* Your normal homepage */}
      <Header />
      <HeroSection />
      <AboutSection />
      <MembershipSection />
      <ClassesSection />
      
      <CoachesSection />
      <GallerySection />
      <TestimonialsSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;